<template>
    <section class="inner">
        <div class="left">
            <div class="top">
                <icon-title title="党建" iconName="kjtzbxueke"></icon-title>
                <div class="item-top">
                    <div class="chart" id="chart1T"></div>
                </div>
                <div class="item-bottom">
                    <div class="chart chart2" id="chart1L"></div>
                    <div class="chart chart2" id="chart1R"></div>
                </div>
            </div>
            <div class="bottom">
                <icon-title title="智库-学会开展决策咨询工作情况" iconName="wenben"></icon-title>
                <div class="chart" id="chart2"></div>
            </div>
        </div>
        <div class="center">
            <div class="top">
                <icon-title title="世界交通运输大会举办情况概览" class="lg" iconName="lunwen"></icon-title>
                <div class="item-top">
                    <div class="chart" id="chart3T"></div>
                </div>
                <div class="item-bottom">
                    <div class="chart chart2" id="chart3L"></div>
                    <div class="chart chart2" id="chart3R"></div>
                </div>
            </div>
            <div class="bottom">
                <icon-title title="一带一路 国际交通联盟发展情况" class="lg" iconName="lunwen"></icon-title>
                <div class="chart chart2" id="chart4L"></div>
                <div class="chart chart2" id="chart4R"></div>
            </div>
        </div>
        <div class="right">
            <div class="top">
                <icon-title title="学术" iconName="wenben"></icon-title>
                <div class="item-top">
                    <div class="chart" id="chart5T"></div>
                </div>
                <div class="item-bottom table-box">
                    <h4>科学技术奖申报及获奖情况</h4>
                    <div class="table">
                        <table v-if="part5Label">
                            <tr>
                                <th width="50%">
                                    年份
                                </th>
                                <th>
                                    申报数量
                                </th>
                            </tr>
                            <tr v-for="(item, index) in part5Label.column" :key="index">
                                <td>{{ item }}</td>
                                <td><i>{{ part5Label.list[index] }}</i></td>
                            </tr>
                        </table>
                    </div>
                    <div class="chart" id="chart5R"></div>
                </div>
            </div>
            <div class="bottom">
                <icon-title title="科普-学会举办科普活动情况" iconName="jinxianshibutong"></icon-title>
                <div class="chart" id="chart6"></div>
            </div>
        </div>
    </section>
</template>
<script>
    import IconTitle from '@/components/icontitle';
    import * as dataJS from '@/assets/scripts/api/ybj';

    const lineColor = '#2F46C1';
    const labelColor = '#B5C8FF';
    const barColor = [ '#06C0FB', '#2F46C1', '#FB058F', '#EF9412', '#30CF6F','#30CF70'];
    const pieColor = [
        {
            'line': '#05C0FB',
            'area': 'rgba(5,192,251,.2)'
        },
        {
            'line': '#FB058F',
            'area': 'rgba(251,5,143,.2)'
        },
        {
            'line': '#30CF70',
            'area': 'rgba(48,207,112,.2)'
        },
        {
            'line': '#EF9412',
            'area': 'rgba(239,148,18,.2)'
        },
        {
            'line': '#05C0FB',
            'area': 'rgba(5,192,251,.2)'
        },
        {
            'line': '#FB058F',
            'area': 'rgba(251,5,143,.2)'
        },
        {
            'line': '#30CF70',
            'area': 'rgba(48,207,112,.2)'
        },
        {
            'line': '#EF9412',
            'area': 'rgba(239,148,18,.2)'
        },
        {
            'line': '#05C0FB',
            'area': 'rgba(5,192,251,.2)'
        },
        {
            'line': '#FB058F',
            'area': 'rgba(251,5,143,.2)'
        }
    ];
    const XAXIS = {
        type: 'category',
        axisLabel: {
            show: true,
            textStyle: {
                color: labelColor,
                fontSize: 14
            }
        },
        axisLine: {
            lineStyle: {
                color: lineColor
            }
        },
        splitLine: {
            show: false
        },
        axisTick: {
            show: true,
            alignWithLabel: true,
            lineStyle: {
                color: lineColor,
            }
        }
    };
    const YAXIS = {
        axisTick: {
            show: false
        },
        axisLine: {
            show: false
        },
        splitLine: {
            show: true,
            lineStyle: {
                color: lineColor,
                type: 'dotted'
            }
        },
        axisLabel: {
            show: true,
            textStyle: {
                color: labelColor,
                fontSize: 12
            },
            formatter: '{value}'
        }
    };

    export default {
        name: 'glxh',
        components: {
            IconTitle
        },
        data() {
            return {
                part5Label: {},
                grid: {
                    x: '5%',
                    x2: '7%',
                    y: '10%',
                    containLabel: true
                }
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {

                // 党建设
                dataJS.getParty().then((res) => {
                    this.initChart1(res.data);
                });

                // 智库
                dataJS.getIdea().then((res) => {
                    this.initChart2(res.data.edu);
                });

                // 交通运输大会举办情况
                dataJS.getTrafficMeet().then((res) => {
                    this.initChart3(res.data);
                });

                // “一带一路”国际交通联盟发展情况
                dataJS.getTrafficLeague().then((res) => {
                    this.initChart4(res.data);
                });

                // 学术
                dataJS.getScholarism().then((res) => {
                    this.part5Label = res.data.two;
                    this.initChart5(res.data);
                });

                // 科普-学会举办科普活动情况
                dataJS.getKepu().then((res) => {
                    this.initChart6(res.data);
                });

            },
            initChart1(data) {
                let chart1L = echarts.init(document.getElementById('chart1L')),
                    chart1R = echarts.init(document.getElementById('chart1R')),
                    optionL = this.getPieOption(data.action, '党建活动类型分布'),
                    optionR = this.getPieOption(data.office, '党员任职分布'),
                    chart1T = echarts.init(document.getElementById('chart1T')),
                    optionT = this.getBarData(data.edu, '党员任职分布', 'bar1');

                chart1L.setOption(optionL, true);
                chart1L.resize();
                this.$winResize(chart1L.resize);
                chart1R.setOption(optionR, true);
                chart1R.resize();
                this.$winResize(chart1R.resize);
                chart1T.setOption(optionT, true);
                chart1T.resize();
                this.$winResize(chart1T.resize);
            },
            initChart2(data) {
                let chart = echarts.init(document.getElementById('chart2')),
                    option = this.getLineData(data,'');

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart3(data) {
                let chart3L = echarts.init(document.getElementById('chart3L')),
                    chart3R = echarts.init(document.getElementById('chart3R')),
                    chart3T = echarts.init(document.getElementById('chart3T')),
                    optionL = this.getBarData(data.two, '', 'abeam', '22%'),
                    optionR = this.getBarData(data.three, '', 'bar'),
                    optionT = this.getBarData(data.one, '', 'complex');

                chart3L.setOption(optionL, true);
                chart3L.resize();
                this.$winResize(chart3L.resize);
                chart3R.setOption(optionR, true);
                chart3R.resize();
                this.$winResize(chart3R.resize);
                chart3T.setOption(optionT, true);
                chart3T.resize();
                this.$winResize(chart3T.resize);
            },
            initChart4(data) {
                let chart4L = echarts.init(document.getElementById('chart4L')),
                    chart4R = echarts.init(document.getElementById('chart4R')),
                    optionL = this.getBarData(data.one, '', 'complex'),
                    optionR = this.getBarData(data.two, '', 'complex');

                chart4L.setOption(optionL, true);
                chart4L.resize();
                this.$winResize(chart4L.resize);
                chart4R.setOption(optionR, true);
                chart4R.resize();
                this.$winResize(chart4R.resize);
            },
            initChart5(data) {
                let chart5T = echarts.init(document.getElementById('chart5T')),
                    chart5R = echarts.init(document.getElementById('chart5R')),
                    optionT = this.getBarData(data.one, '学会举办的各类学术活动情况', 'complex'),
                    optionR = this.getBarData(data.three, '', 'abeamAll', '22%');

                chart5T.setOption(optionT, true);
                chart5T.resize();
                this.$winResize(chart5T.resize);
                chart5R.setOption(optionR, true);
                chart5R.resize();
                this.$winResize(chart5R.resize);
            },
            initChart6(data) {
                let chart6 = echarts.init(document.getElementById('chart6')),
                    option = this.getBarData(data, '', 'complex');

                chart6.setOption(option, true);
                chart6.resize();
                this.$winResize(chart6.resize);
            },
            getLineData(data, title) {
                let option;

                let seriesData = data.list.map((item, index) => {
                    return {
                        name: data.title[index],
                        type: 'line',
                        smooth: true,
                        symbol: 'circle',
                        itemStyle: {
                            normal: {
                                color: pieColor[index].line,
                                lineStyle: {
                                    color: pieColor[index].line
                                }
                            },
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: pieColor[index].line
                                }, {
                                    offset: 1,
                                    color: pieColor[index].area
                                }])
                            }
                        },
                        data: item
                    }
                });

                option = {
                    title: {
                        text: title,
                        textStyle: {
                            color: labelColor,
                            fontSize: 13
                        },
                        top: 0,
                        left: '5%'
                    },
                    color: barColor,
                    grid: {
                        left: '5%',
                        right: '7%',
                        top: title ? '20%' : '10%',
                        bottom: '20%',
                        containLabel: true
                    },
                    legend: {
                        itemWidth: 6,
                        itemHeight: 6,
                        icon: 'circle',
                        data: data.title,
                        bottom: '2%',
                        textStyle: {
                            color: labelColor
                        }
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: Object.assign({
                        data: data.column
                    }, XAXIS),
                    yAxis: YAXIS,
                    series: seriesData
                };

                return option;

            },
            getBarData(data, title, type ,bottom) {
                let seriesData = [],
                    option,
                    xAxis = Object.assign({
                        data: data.column
                    }, XAXIS),
                    yAxis = YAXIS,
                    y = title ? '22%' : '10%';


                switch (type) {
                case 'complex':
                    yAxis = this.returnComplexData(data).yAxis;
                    seriesData = this.returnComplexData(data).seriesData;
                    break;
                case 'bar':
                    seriesData = this.returnBarData(data);
                    break;
                case 'bar1':
                    seriesData = this.returnBarData(data);
                    break;
                case 'abeamAll':
                    xAxis = this.returnAbeamData(data, 'all').xAxis;
                    yAxis = this.returnAbeamData(data, 'all').yAxis;
                    seriesData = this.returnAbeamData(data, 'all').seriesData;
                    break;
                case 'abeam':
                    xAxis = this.returnAbeamData(data).xAxis;
                    yAxis = this.returnAbeamData(data).yAxis;
                    seriesData = this.returnAbeamData(data).seriesData;
                    break;
                }

                option = {
                    title: {
                        text: title,
                        top: 0,
                        left: '5%',
                        textStyle: {
                            color: labelColor,
                            fontSize: 14
                        }
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    grid: {
                        left: '3%',
                        right: '3%',
                        top: y,
                        bottom:bottom? bottom: '13%',
                        containLabel: true
                    },
                    legend: {
                        bottom: '2%',
                        data: data.title,
                        itemWidth: 12,
                        itemHeight: 12,
                        itemGap:0,
                        textStyle: {
                            color: labelColor
                        }
                    },
                    xAxis: xAxis,
                    yAxis: yAxis,
                    series: seriesData
                };

                return option;
            },
            returnAbeamData(data,type) {
                let seriesData = [],
                    xAxis,
                    yAxis,
                    stack = type == 'all' ? '总量' : '';

                data.list.forEach((item, index) => {
                    seriesData.push({
                        type: 'bar',
                        barWidth: '30%',
                        stack: stack,
                        name: data.title[index],
                        itemStyle: {
                            color: barColor[index]
                        },
                        data: item
                    });
                });

                xAxis = {
                    type: 'value',
                    axisLine: {
                        show: false
                    },
                    splitNumber: 4,
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: lineColor,
                            width: 1,
                            type: 'solid'
                        }
                    },
                    axisLabel: {
                        color: labelColor,
                    }
                };

                yAxis ={
                    type: 'category',
                    axisLine: {
                        lineStyle: {
                            color: lineColor
                        }
                    },
                    axisLabel: {
                        color: labelColor
                    },
                    axisTick: {
                        show: true
                    },
                    data: data.column
                };

                return { seriesData, xAxis, yAxis };
            },
            returnBarData(data) {
                let seriesData = data.list.map((item, index) => {
                    return {
                        type: 'bar',
                        barWidth: '25%',
                        barGap: 1,
                        name: data.title[index],
                        itemStyle: {
                            normal: {
                                show: true,
                                color: barColor[index]
                            }
                        },
                        data: item
                    };
                });

                return seriesData;
            },
            returnComplexData(data) {
                let seriesData = [],
                    yAxis,
                    max1 = Math.max.apply(null, data.list[0]),
                    max2 = Math.max.apply(null, data.list[1]);

                seriesData = [
                    {
                        name: data.title[0],
                        type: 'bar',
                        barWidth: '25%',
                        itemStyle: {
                            normal: {
                                color: barColor[0]
                            }
                        },
                        yAxisIndex: 0,
                        data: data.list[0]
                    },
                    {
                        name: data.title[1],
                        type: 'line',
                        symbol: 'none',
                        smooth: true,
                        itemStyle: {
                            normal: {
                                color: barColor[2]
                            }
                        },
                        yAxisIndex: 1,
                        data: data.list[1]
                    }];

                yAxis = [
                    Object.assign({
                        type: 'value',
                        min: 0,
                        max: max1,
                    }, YAXIS),
                    Object.assign({
                        type: 'value',
                        min: 0,
                        max: max2
                    }, YAXIS)
                ];

                return {seriesData, yAxis};
            },
            getPieOption(data, name) {
                let seriesData = [],
                    option = {};

                data.list.forEach((item, index) => {
                    let obj = {};

                    obj.value = parseFloat(item);
                    obj.name = data.column[index];

                    if (index == 0) {
                        obj.selected = true;
                    }
                    seriesData.push(obj);
                });

                option = {
                    tooltip: {
                        trigger: 'item'
                    },
                    title: {
                        text: name,
                        textStyle: {
                            color: labelColor,
                            fontSize: 13
                        },
                        top: 0,
                        left: '5%'
                    },
                    grid: {
                        left: '0',
                        right: '0',
                        bottom: '13%',
                        top: '20%',
                        containLabel: true
                    },
                    color: barColor,
                    series: [{
                        name: '',
                        type: 'pie',
                        radius: [0, '60%'],
                        center: ['50%', '60%'],
                        label: {
                            show: false
                        },
                        data: seriesData
                    }]
                };

                return option;
            }
        }
    };
</script>
<style lang="scss" scoped>

    @import "~@/assets/scss/mixins/_mixins.scss";

    $titleColor: #B5C8FF;
    $borderColor: #17215F;
    $borderDrakColor: #080B26;

    .inner {
        padding: 2% 2.08% 0;
        font-size:.16rem;

        ::v-deep.title-line-main {
            margin-right: 0 !important;
        }

        .top {
            height: 50%;
        }

        .bottom {
            height: 50%;
        }

        .left {
            float: left;
            width: 26.8%;
            height: 100%;

        }

        .right {
            @extend .left;
            float: right;
        }

        .center {
            float: left;
            width: 43%;
            height: 100%;
            margin: 0 1.6%;
        }

        .top {
            height: 56.8%;
        }

        .bottom {
            height: 39.1%;
        }

        .item-top{
            width:100%;
            height: 50%;
        }

        .item-bottom{
            width:100%;
            height: calc(50% - 34px);
        }


        .chart {
            width: 100%;
            height: 100%;
        }

        .chart2{
            width:50%;
            float: left;
        }

        .chart3,.chart5{
            width: 72%;
            float: left;
        }


        .table-box {
            .chart{
                width: 64.8%;
                float: right;
                height: calc(100% - .4rem);
            }

            h4 {
                line-height: .4rem;
                color: $titleColor;
                font-size: .14rem;
                padding-left: .2rem;
                border: 1px solid $borderColor;
            }

            .table {
                width: 35.2%;
                float: left;
                height: calc(100% - .4rem);

                table {
                    width: 100%;
                    height:100%;
                    text-align: center;
                    border: 1px solid $borderColor;
                }
                tr {
                    height: 10%;
                    border-bottom: 1px solid $borderColor;
                    &:last-child {
                        border: none;
                    }
                }
                td, th {
                    border-right: 1px solid $borderColor;
                    &:last-child {
                        border: none;
                    }
                    &:first-child {
                        color: $titleColor;
                    }
                }
                th {
                    color: $titleColor;
                }
                i {
                    color: #ffc02f;
                }
            }
        }

        .chart4-left{
            width:50%;
            height:100%;
            float: left;

            .label {
                height: .5rem;
                overflow: hidden;
                margin: .2rem 0;
                box-sizing: border-box;
                span {
                    float: left;
                    border: 1px solid #40E4FE;
                    color: #40E4FE;
                    border-radius: 10px;
                    height: .5rem;
                    line-height: .5rem;
                    padding:0 .1rem;
                    margin: 0 .1rem;
                    cursor: pointer;
                }
                .checked {
                    border: 1px solid #FFC02F;
                    color: #FFC02F;
                }
            }

            &:first-child{

                .chart{
                    height: calc(100% - .9rem);
                }
            }
        }
    }
</style>